export default "__VITE_ASSET__4oaqVzFz__"